import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import Header from './components/Header';
import StudyVisaPage from './pages/StudyVisaPage';
import Footer from './components/Footer';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <Header />
        <main>
          <StudyVisaPage />
        </main>
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;
